import React, {Component} from 'react';
import {Header} from './Header';
import {Footer} from './Footer';
import {Link} from "react-router-dom";
import {faqPageText as faqPageText_en} from "../libs/en/texts-faqs-page-lib";
import {faqPageText as faqPageText_en_ca} from "../libs/en-ca/texts-faqs-page-lib";
import {faqPageText as faqPageText_de} from "../libs/de/texts-faqs-page-lib";
import {faqPageText as faqPageText_de_ch} from "../libs/de-ch/texts-faqs-page-lib";
import {faqPageText as faqPageText_fr} from "../libs/fr/texts-faqs-page-lib";
import {faqPageText as faqPageText_fr_fr} from "../libs/fr-fr/texts-faqs-page-lib";
import {faqPageText as faqPageText_fr_ca} from "../libs/fr-ca/texts-faqs-page-lib";
import {faqPageText as faqPageText_nl} from "../libs/nl/texts-faqs-page-lib";
import {faqPageText as faqPageText_it} from "../libs/it/texts-faqs-page-lib";
import {faqPageText as faqPageText_it_ch} from "../libs/it-ch/texts-faqs-page-lib";
import {faqPageText as faqPageText_cz} from "../libs/cz/texts-faqs-page-lib";
import {faqPageText as faqPageText_fi} from "../libs/fi/texts-faqs-page-lib";
import {faqPageText as faqPageText_pl} from "../libs/pl/texts-faqs-page-lib";
import {faqPageText as faqPageText_se} from "../libs/se/texts-faqs-page-lib";
import {faqPageText as faqPageText_no} from "../libs/no/texts-faqs-page-lib";
import {faqPageText as faqPageText_dk} from "../libs/dk/texts-faqs-page-lib";
import {faqPageText as faqPageText_es} from "../libs/es/texts-faqs-page-lib";
import {faqPageText as faqPageText_pt} from "../libs/pt/texts-faqs-page-lib";
import {headerText as headerText_en} from "../libs/en/texts-header-lib";
import {headerText as headerText_de} from "../libs/de/texts-header-lib";
import {headerText as headerText_de_ch} from "../libs/de-ch/texts-header-lib";
import {headerText as headerText_fr} from "../libs/fr/texts-header-lib";
import {headerText as headerText_fr_ca} from "../libs/fr-ca/texts-header-lib";
import {headerText as headerText_nl} from "../libs/nl/texts-header-lib";
import {headerText as headerText_it} from "../libs/it/texts-header-lib";
import {headerText as headerText_it_ch} from "../libs/it-ch/texts-header-lib";
import {headerText as headerText_cz} from "../libs/cz/texts-header-lib";
import {headerText as headerText_fi} from "../libs/fi/texts-header-lib";
import {headerText as headerText_pl} from "../libs/pl/texts-header-lib";
import {headerText as headerText_se} from "../libs/se/texts-header-lib";
import {headerText as headerText_no} from "../libs/no/texts-header-lib";
import {headerText as headerText_dk} from "../libs/dk/texts-header-lib";
import {headerText as headerText_es} from "../libs/es/texts-header-lib";
import {headerText as headerText_pt} from "../libs/pt/texts-header-lib";
import parse from "html-react-parser";
import {Helmet} from 'react-helmet';
import {getLanguageFromPath, getLanguagePrefix} from "../utils/language";

class Accordion extends Component {
    constructor() {
        super();
        this._handleClick = this._handleClick.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        window.addEventListener('resize', this.resize);
        this._handleClick();

    }

    _handleClick() {
        let acc = this._acc.getElementsByClassName('accordian-title');
        for (let i = 0; i < acc.length; i++) {
            let a = acc[i];
            a.onclick = () => a.classList.toggle("active");
        }
    }

    render() {
        return (
            <div
                ref={a => this._acc = a}
                onClick={this._handleClick}>
                {this.props.children}
            </div>
        )
    }
}

export class Faq extends Component {
    getEffectiveLanguage() {
        return getLanguageFromPath(window.location.pathname);
    }

    getFaqTextsForLanguage(language) {
        if (language === "DE") {
            return {faqPageText: faqPageText_de, headerText: headerText_de};
        }
        if (language === "DE-CH") {
            return {faqPageText: faqPageText_de_ch, headerText: headerText_de_ch};
        }
        if (language === "EN-CA" || language === "EN-CA-none") {
            return {faqPageText: faqPageText_en_ca, headerText: headerText_en};
        }
        if (language === "FR") {
            return {faqPageText: faqPageText_fr, headerText: headerText_fr};
        }
        if (language === "FR-FR") {
            return {faqPageText: faqPageText_fr_fr, headerText: headerText_fr};
        }
        if (language === "FR-CA" || language === "FR-CA-none") {
            return {faqPageText: faqPageText_fr_ca, headerText: headerText_fr_ca};
        }
        if (language === "NL") {
            return {faqPageText: faqPageText_nl, headerText: headerText_nl};
        }
        if (language === "IT") {
            return {faqPageText: faqPageText_it, headerText: headerText_it};
        }
        if (language === "IT-CH") {
            return {faqPageText: faqPageText_it_ch, headerText: headerText_it_ch};
        }
        if (language === "CZ") {
            return {faqPageText: faqPageText_cz, headerText: headerText_cz};
        }
        if (language === "FI") {
            return {faqPageText: faqPageText_fi, headerText: headerText_fi};
        }
        if (language === "PL") {
            return {faqPageText: faqPageText_pl, headerText: headerText_pl};
        }
        if (language === "SE") {
            return {faqPageText: faqPageText_se, headerText: headerText_se};
        }
        if (language === "NO") {
            return {faqPageText: faqPageText_no, headerText: headerText_no};
        }
        if (language === "DK") {
            return {faqPageText: faqPageText_dk, headerText: headerText_dk};
        }
        if (language === "ES") {
            return {faqPageText: faqPageText_es, headerText: headerText_es};
        }
        if (language === "PT") {
            return {faqPageText: faqPageText_pt, headerText: headerText_pt};
        }
        return {faqPageText: faqPageText_en, headerText: headerText_en};
    }

    constructor(props) {
        super(props);
        const language = this.getEffectiveLanguage();
        const texts = this.getFaqTextsForLanguage(language);
        this.state = {
            block1: true,
            block2: false,
            block3: false,
            language,
            ...texts,
        };
    }

    setLanguageVars() {
        const language = this.getEffectiveLanguage();
        if (this.props.language !== language && this.props.setSiteLanguage) {
            this.props.setSiteLanguage(language);
        }
        if (this.state.language !== language) {
            this.setState({
                language,
                ...this.getFaqTextsForLanguage(language),
            });
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.setLanguageVars();
    }

    componentDidUpdate() {
        this.setLanguageVars();
    }

    toggle = (index) => () => {
        this.setState({[`block${index}`]: !this.state[`block${index}`]});
    };

    toggleExpand = (expand = false) => () => {
        this.setState({
            block1: expand,
            block2: expand,
            block3: expand,
        });
    };

    isCaLocale() {
        const lang = this.state.language;
        return lang === 'EN-CA' || lang === 'EN-CA-none' || lang === 'FR-CA' || lang === 'FR-CA-none';
    }

    renderCaCompatibilityLink(answer1, answer2, answer3) {
        const t = this.state.faqPageText;
        const href = t.caCompatibilityListHtml || t.whatPhoneAnswerLibreHtml;
        if (!answer2 || !href) {
            return null;
        }

        return (
            <p>
                {parse(answer1)}
                <a href={href}
                   target="_blank"
                   rel="noopener noreferrer">
                    {parse(answer2)}</a>
                {parse(answer3)}
            </p>
        );
    }

    renderSensorLinkedParagraph(text) {
        const t = this.state.faqPageText;
        const lang = this.state.language;
        const isCaLocale = lang === 'EN-CA' || lang === 'EN-CA-none' || lang === 'FR-CA' || lang === 'FR-CA-none';
        const isFrFrLocale = lang === 'FR-FR';

        if (!text) {
            return null;
        }

        const sensors = [
            ...(isFrFrLocale ? [] : [{name: 'FreeStyle Libre 3 Plus', href: t.whatPhoneAnswerLibreHtml, title: 'FreeStyle Libre 3 Plus System'}]),
            {name: 'FreeStyle Libre 3', href: t.whatPhoneAnswerLibreHtml, title: 'FreeStyle Libre 3 System'},
            ...(isCaLocale || isFrFrLocale ? [] : [{name: 'Dexcom G7', href: t.whatPhoneAnswerDexcomG7Html, title: 'Dexcom G7'}]),
            {name: 'Dexcom G6', href: t.whatPhoneAnswerDexcomHtml, title: 'Dexcom G6'},
        ];

        const pattern = new RegExp(
            `(${sensors.map((sensor) => sensor.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')})`,
            'g',
        );
        const parts = text.split(pattern);

        return parts.map((part, index) => {
            const sensor = sensors.find((entry) => entry.name === part);
            if (sensor && sensor.href) {
                return (
                    <a key={index}
                       href={sensor.href}
                       title={sensor.title}
                       target="_blank"
                       rel="noopener noreferrer">{part}</a>
                );
            }
            return part ? <React.Fragment key={index}>{parse(part)}</React.Fragment> : null;
        });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>{parse(this.state.faqPageText.title)}</title>
                    <meta name="title" content={parse(this.state.faqPageText.titleMeta)}/>
                    <meta name="description"
                          content={parse(this.state.faqPageText.descriptionMeta)}/>
                    <meta name="keywords" content={this.state.faqPageText.keywords}/>
                    <meta property="og:locale" content={this.state.faqPageText.localeMeta}/>
                </Helmet>
                <Header props={{...this.props, language: this.state.language}}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-md-8 col-xl-9">
                                <h1>{parse(this.state.faqPageText.haveQuestion)}</h1>
                                <p>{parse(this.state.faqPageText.hereAnswers)}</p>
                                {/*<p><br/></p>*/}
                                {/*{(this.state.language === "EN") &&*/}
                                {/*<NavLink to={"/info"} className="btn">*/}
                                {/*    Send me info</NavLink>}*/}
                            </div>
                        </div>
                    </div>
                </section>
                <section className="faq-main">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <Accordion>

                                    <div className="accordian-col">
                                        <div className="accordian-title">
                                            <h4>{parse(this.state.faqPageText.whatIsCamAPS)}</h4></div>
                                        <div className="accordian-content">
                                            <p>{parse(this.state.faqPageText.whatIsCamAPSAnswer)}</p>
                                        </div>
                                    </div>

                                    {(this.state.language !== "FR-FR") &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.faqPageText.isApproved)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.faqPageText.isApprovedAnswer)}</p>
                                            </div>
                                        </div>
                                    }

                                    {(this.state.language !== "FR-FR") &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.faqPageText.isAvailable)}</h4>
                                            </div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.faqPageText.isAvailableAnswer1)} <Link
                                                    to="/orders">{parse(this.state.faqPageText.isAvailableAnswer2)}
                                                </Link> {parse(this.state.faqPageText.isAvailableAnswer3)}</p>
                                            </div>
                                        </div>
                                    }

                                    {/* active for EN only*/}
                                    {this.state.faqPageText.whatIsLiberty && (this.state.language === 'EN') &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.faqPageText.whatIsLiberty)}</h4>
                                            </div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.faqPageText.whatIsLibertyAnswer)}</p>
                                                <p>
                                                    {parse(this.state.faqPageText.whatIsLibertyMoreInfo1)}
                                                    <a
                                                        href={(['EN-CA', 'FR-CA', 'FR-FR'].includes(this.state.language) ? '' : getLanguagePrefix(this.state.language)) + '/liberty'}
                                                        style={{textDecoration: 'underline'}}
                                                    >
                                                        {parse(this.state.faqPageText.whatIsLibertyPageLink)}
                                                    </a>
                                                    {parse(this.state.faqPageText.whatIsLibertyMoreInfo2)}
                                                    <a
                                                        href={parse(this.state.faqPageText.whatIsLibertyFactsheetUrl)}
                                                        style={{textDecoration: 'underline'}}
                                                    >
                                                        {parse(this.state.faqPageText.whatIsLibertyFactsheetLink)}
                                                    </a>
                                                    {parse(this.state.faqPageText.whatIsLibertyMoreInfo3 || '')}
                                                </p>
                                            </div>
                                        </div>
                                    }
                                    
                                    {/*{(this.state.language !== "FR-FR") &&*/}
                                    {/*    <div className="accordian-col">*/}
                                    {/*        <div className="accordian-title">*/}
                                    {/*            <h4>{parse(this.state.faqPageText.cost)}</h4>*/}
                                    {/*        </div>*/}
                                    {/*        <div className="accordian-content">*/}
                                    {/*            <p>{parse(this.state.faqPageText.costAnswer1)} <Link*/}
                                    {/*                to="/orders">{parse(this.state.headerText.tabOrders)}*/}
                                    {/*            </Link> {parse(this.state.faqPageText.costAnswer2)}</p>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*}*/}

                                    <div className="accordian-col">
                                        <div className="accordian-title">
                                            <h4>{parse(this.state.faqPageText.compatibleCgm)}</h4></div>
                                        <div className="accordian-content">
                                            <p>
                                                {this.renderSensorLinkedParagraph(this.state.faqPageText.compatibleCgmBody)}
                                            </p>
                                            {(this.state.language !== "EN-CA-none") && (this.state.language !== "FR-CA-none") && (
                                                <p>
                                                    {parse(this.state.faqPageText.wantMoreInfoIOSanswer1)}
                                                    <a href={parse(this.state.faqPageText.wantMoreInfoCGManswerHtml)}
                                                       title={parse(this.state.faqPageText.wantMoreInfoIOSanswer2)}
                                                       target="_blank"
                                                       rel="noopener noreferrer">
                                                        {parse(this.state.faqPageText.wantMoreInfoIOSanswer2)}</a>
                                                    {'\u00A0'}
                                                    {parse(this.state.faqPageText.wantMoreInfoIOSanswer3)}
                                                </p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="accordian-col">
                                        <div className="accordian-title">
                                            <h4>{parse(this.state.faqPageText.whatPumps)}</h4></div>
                                        <div className="accordian-content">
                                            <p>{parse(this.state.faqPageText.whatPumpsAnswer1)}</p>
                                            {this.state.faqPageText.whatPumpsAnswer3 &&
                                                <p>{parse(this.state.faqPageText.whatPumpsAnswer3)}</p>
                                            }
                                        </div>
                                    </div>

                                    <div className="accordian-col">
                                        <div className="accordian-title">
                                            <h4>{parse(this.state.faqPageText.whatPhone)}</h4></div>
                                        <div className="accordian-content">
                                            {this.isCaLocale()
                                                ? this.renderCaCompatibilityLink(
                                                    this.state.faqPageText.whatPhoneListAnswer1,
                                                    this.state.faqPageText.whatPhoneListAnswer2,
                                                    this.state.faqPageText.whatPhoneListAnswer3,
                                                )
                                                : (
                                                    <>
                                                        <p>{parse(this.state.faqPageText.whatPhoneAnswer)}</p>
                                                        <p>{this.renderSensorLinkedParagraph(this.state.faqPageText.cgmManufacturerListText)}</p>
                                                    </>
                                                )}
                                        </div>
                                    </div>

                                    {this.state.faqPageText.whatOperating &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.faqPageText.whatOperating)}</h4></div>
                                            <div className="accordian-content">
                                                {this.isCaLocale()
                                                    ? this.renderCaCompatibilityLink(
                                                        this.state.faqPageText.whatOperatingListAnswer1,
                                                        this.state.faqPageText.whatOperatingListAnswer2,
                                                        this.state.faqPageText.whatOperatingListAnswer3,
                                                    )
                                                    : (
                                                        <>
                                                            <p>{parse(this.state.faqPageText.whatOperatingAnswer)}</p>
                                                            <p>{this.renderSensorLinkedParagraph(this.state.faqPageText.whatOperatingManufacturerText)}</p>
                                                        </>
                                                    )}
                                            </div>
                                        </div>
                                    }

                                    {/*/!* This is used to code for non France 11 Jun 2025*!/*/}
                                    {/*{(this.state.language !== "FR-FR") &&*/}
                                    {/*    <div className="accordian-col">*/}
                                    {/*        <div className="accordian-title">*/}
                                    {/*            <h4>{parse(this.state.faqPageText.whatPhone)}</h4></div>*/}
                                    {/*        <div className="accordian-content">*/}
                                    {/*            <p>*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer)}*/}
                                    {/*            </p>*/}
                                    {/*            <p>*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer1)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                <a href={parse(this.state.faqPageText.whatPhoneAnswerDexcomHtml)}*/}
                                    {/*                   title={parse(this.state.faqPageText.whatPhoneAnswer2)}*/}
                                    {/*                   target="_blank"*/}
                                    {/*                   rel="noopener noreferrer">*/}
                                    {/*                    {parse(this.state.faqPageText.whatPhoneAnswer2)}</a>*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer3)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswerDexcom)}*/}
                                    {/*                &nbsp;*/}
                                    {/*            </p>*/}
                                    {/*            <p>*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer1)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                <a href={parse(this.state.faqPageText.whatPhoneAnswerLibreHtml)}*/}
                                    {/*                   title={parse(this.state.faqPageText.whatPhoneAnswer2)}*/}
                                    {/*                   target="_blank"*/}
                                    {/*                   rel="noopener noreferrer">*/}
                                    {/*                    {parse(this.state.faqPageText.whatPhoneAnswer2)}</a>*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer3)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswerLibre3)}*/}
                                    {/*                &nbsp;*/}
                                    {/*            </p>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*}*/}


                                    {/*/!* This is used to code for non France 11 Jun 2025*!/*/}
                                    {/*{(this.state.language !== "FR-FR") &&*/}
                                    {/*    <div className="accordian-col">*/}
                                    {/*        <div className="accordian-title">*/}
                                    {/*            <h4>{parse(this.state.faqPageText.whatPhone)}</h4></div>*/}
                                    {/*        <div className="accordian-content">*/}
                                    {/*            <p>*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer)}*/}
                                    {/*            </p>*/}
                                    {/*            /!*<p>*!/*/}
                                    {/*            /!*    {parse(this.state.faqPageText.whatPhoneAnswer1)}*!/*/}
                                    {/*            /!*    &nbsp;*!/*/}
                                    {/*            /!*    <a href={parse(this.state.faqPageText.whatPhoneAnswerDexcomHtml)}*!/*/}
                                    {/*            /!*       title={parse(this.state.faqPageText.whatPhoneAnswer2)}*!/*/}
                                    {/*            /!*       target="_blank"*!/*/}
                                    {/*            /!*       rel="noopener noreferrer">*!/*/}
                                    {/*            /!*        {parse(this.state.faqPageText.whatPhoneAnswer2)}</a>*!/*/}
                                    {/*            /!*    &nbsp;*!/*/}
                                    {/*            /!*    {parse(this.state.faqPageText.whatPhoneAnswer3)}*!/*/}
                                    {/*            /!*    &nbsp;*!/*/}
                                    {/*            /!*    {parse(this.state.faqPageText.whatPhoneAnswerDexcom)}*!/*/}
                                    {/*            /!*    &nbsp;*!/*/}
                                    {/*            /!*</p>*!/*/}
                                    {/*            <p>*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer1)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                <a href={parse(this.state.faqPageText.whatPhoneAnswerLibreHtml)}*/}
                                    {/*                   title={parse(this.state.faqPageText.whatPhoneAnswer2)}*/}
                                    {/*                   target="_blank"*/}
                                    {/*                   rel="noopener noreferrer">*/}
                                    {/*                    {parse(this.state.faqPageText.whatPhoneAnswer2)}</a>*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer3)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswerLibre3)}*/}
                                    {/*                &nbsp;*/}
                                    {/*            </p>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*}*/}

                                    {/*/!* This is used to be code for France 11 Jun 2025*!/*/}
                                    {/*{(this.state.language === "FR-FR") &&*/}
                                    {/*    <div className="accordian-col">*/}
                                    {/*        <div className="accordian-title">*/}
                                    {/*            <h4>{parse(this.state.faqPageText.whatPhone)}</h4></div>*/}
                                    {/*        <div className="accordian-content">*/}
                                    {/*            <p>*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer)}*/}
                                    {/*            </p>*/}
                                    {/*            <p>*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer1)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                <a href={parse(this.state.faqPageText.whatPhoneAnswerDexcomHtml)}*/}
                                    {/*                   title={parse(this.state.faqPageText.whatPhoneAnswer2)}*/}
                                    {/*                   target="_blank"*/}
                                    {/*                   rel="noopener noreferrer">*/}
                                    {/*                    {parse(this.state.faqPageText.whatPhoneAnswer2)}</a>*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswer3)}*/}
                                    {/*                &nbsp;*/}
                                    {/*                {parse(this.state.faqPageText.whatPhoneAnswerDexcom)}*/}
                                    {/*                &nbsp;*/}
                                    {/*            </p>*/}
                                    {/*        </div>*/}
                                    {/*    </div>*/}
                                    {/*}*/}

                                    {(this.state.language === "EN") &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.faqPageText.danaOnGooglePlayHeading)}</h4></div>
                                            <div className="accordian-content">
                                                <p>
                                                    {parse(this.state.faqPageText.danaOnGooglePlayAnswer1)}
                                                    &nbsp;
                                                    <a href={parse(this.state.faqPageText.danaOnGooglePlayAnswerHtml)}
                                                       title={parse(this.state.faqPageText.danaOnGooglePlayAnswer2)}
                                                       target="_blank"
                                                       rel="noopener noreferrer">
                                                        {parse(this.state.faqPageText.danaOnGooglePlayAnswer2)}</a>
                                                    &nbsp;
                                                    {parse(this.state.faqPageText.danaOnGooglePlayAnswer3)}
                                                    &nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    }

                                    <div className="accordian-col">
                                        <div className="accordian-title">
                                            <h4>{parse(this.state.faqPageText.wantMoreInfoIOS)}</h4></div>
                                        <div className="accordian-content">
                                            <p>
                                                {parse(this.state.faqPageText.wantMoreInfoIOSanswer1)}
                                                &nbsp;
                                                <a href={parse(this.state.faqPageText.wantMoreInfoIOSanswerHtml)}
                                                   title={parse(this.state.faqPageText.wantMoreInfoIOSanswer2)}
                                                   target="_blank"
                                                   rel="noopener noreferrer">
                                                    {parse(this.state.faqPageText.wantMoreInfoIOSanswer2)}</a>
                                                &nbsp;
                                                {parse(this.state.faqPageText.wantMoreInfoIOSanswer3)}
                                                &nbsp;
                                            </p>
                                        </div>
                                    </div>

                                    <div className="accordian-col">
                                        <div className="accordian-title">
                                            <h4>{parse(this.state.faqPageText.whereUpload)}</h4></div>
                                        <div className="accordian-content">
                                            <p>{parse(this.state.faqPageText.whereUploadAnswer)}
                                                {/*<a*/}
                                                {/*href="https://glooko.com"*/}
                                                {/*title="Glooko XT" target="_blank"*/}
                                                {/*rel="noopener noreferrer">Glooko</a>.*/}
                                                {/*Other cloud portals such as Clarity may become available in the future.*/}
                                            </p>
                                        </div>
                                    </div>

                                    <div className="accordian-col">
                                        <div className="accordian-title">
                                            <h4>{parse(this.state.faqPageText.whatLanguage)}</h4></div>
                                        <div className="accordian-content">
                                            <p>{parse(this.state.faqPageText.whatLanguageAnswer)}</p>
                                        </div>
                                    </div>

                                    {(this.state.language !== "FR-FR") &&
                                        <div className="accordian-col">
                                            <div className="accordian-title">
                                                <h4>{parse(this.state.faqPageText.whereResults)}</h4></div>
                                            <div className="accordian-content">
                                                <p>{parse(this.state.faqPageText.whereResultsAnswer1)} <a
                                                    href="https://s3-eu-west-1.amazonaws.com/camdiab.trial.data/CamAPS+FX+related+publications.zip"
                                                    title="Publications" target="_blank"
                                                    rel="noopener noreferrer">{parse(this.state.faqPageText.whereResultsAnswer2)}
                                                </a> {parse(this.state.faqPageText.whereResultsAnswer3)} <a
                                                    href="https://www.thelancet.com/journals/lancet/article/PIIS0140-6736(18)31947-0/fulltext"
                                                    title="Lancet 2018" target="_blank" rel="noopener noreferrer">The
                                                    Lancet</a> {parse(this.state.faqPageText.whereResultsAnswer4)} <a
                                                    href="https://www.nejm.org/doi/10.1056/NEJMoa1509351"
                                                    title="NEJM 2015" target="_blank" rel="noopener noreferrer">The New
                                                    England Journal of Medicine</a>.</p>
                                                    
                                            </div>
                                        </div>}
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}

